import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

import { mode } from 'template/material-theme'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    // ----------------------------------------------
    // Container

    container: {
      paddingTop: theme.spacing(4),
      '& a': {
        color: 'inherit',
      },
    },
    
    // ----------------------------------------------
    // Liste

    brandsCarousel: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),

      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),

      position: 'relative',
      userSelect: 'none',

    },

    brandSwiper: {
      overflowY: 'hidden',
      touchAction: 'pan-x pan-y pinch-zoom',
      overscrollBehaviorX: 'contain',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '& .swiper-wrapper': {
        alignItems: 'center',
        // cssMode scrolls this element, not the outer .swiper container.
        overflowX: 'auto',
        overflowY: 'hidden',
        height: 70,
      },
      '& .swiper-slide': {
        backfaceVisibility: 'hidden',
        boxSizing: 'border-box',
        height: 70,
        transform: 'translateZ(0)',
        width: 70,

        '& a': {
          display: 'flex',
          width: '100%',
          height: '100%',
          alignItems: 'center',
        },

        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          filter: mode === 'dark' ? 'invert(100%)' : undefined,
        },
      },
    },
    spaciousBrandsCarousel: {
      minWidth: 0,
      maxWidth: '100%',
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      // Keep the controls beside the logos, inside the available page width.
      paddingLeft: 44,
      paddingRight: 44,
    },
    spaciousBrandSwiper: {
      overflow: 'visible',
      '& .swiper-wrapper': {
        height: 110,
        overflowX: 'auto',
        overflowY: 'hidden',
        overscrollBehaviorX: 'contain',
        touchAction: 'pan-x pan-y pinch-zoom',
      },
      '& .swiper-slide': {
        width: 152,
        height: 110,
        transform: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        '& .swiper-wrapper': { height: 94 },
        '& .swiper-slide': { width: 120, height: 94 },
      },
    },
    
    // ----------------------------------------------
    // Liste

    brandList: {
      marginTop: theme.spacing(4),

      h4: {
        fontWeight: 'bold',
      },

      '& ul': {
        marginBottom: theme.spacing(6),
        display: 'grid',
        rowGap: theme.spacing(2),
        gridTemplateColumns: 'repeat(1, 1fr)',

        [theme.breakpoints.up('sm')]: { gridTemplateColumns: 'repeat(2, 1fr)', columnGap: theme.spacing(8),},
        [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(3, 1fr)'},
        [theme.breakpoints.up('lg')]: { gridTemplateColumns: 'repeat(4, 1fr)'},

        listStyleType: 'none',
        margin: 0,
        padding: 0,

        '& li': {
          '& a': {
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            }
          },
        },
      }
    },

    // ----------------------------------------------

  })
)

export default useStyles
